// extracted by mini-css-extract-plugin
export var box = "_8m-1";
export var checked = "_8m-2";
export var descriptionSpacer = "_8m-9";
export var disabled = "_8m-3";
export var icon = "_8m-6";
export var input = "_8m-0";
export var labelSpacer = "_8m-8";
export var medium = "_8m-5";
export var small = "_8m-4";
export var text = "_8m-7";